import {
   Component, ComponentRef, ComponentFactoryResolver, ElementRef, EventEmitter, HostListener,
   Input, OnInit, OnDestroy, Output, ViewChild, ViewContainerRef
} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {ShareDownloadFolderComponent} from '../share-download-folder/share-download-folder.component';
import {TranslateService} from '@ngx-translate/core';
import {Mimetype} from 'app/shared/mimetype';
import {Toast} from 'app/shared/toast/toast';
import {AppComponent} from 'app/app.component';
import {DomSanitizer} from '@angular/platform-browser';
import {DocTypeComponent} from '../../../shared/doctype.component';

declare let $: any;
declare let gapi: any;

@Component({
   selector: 'app-sharelist',
   templateUrl: './sharelist.component.html',
   styleUrls: ['../../doclist/doclist.component.css'],
   animations: [
      trigger('tabChange', [
         state('hide', style({
            display: 'none',
            opacity: 0
         })),
         state('show', style({
            display: 'block',
            opacity: 1
         })),
         transition('hide => show', animate('150ms ease-in')),
         transition('show => hide', animate('150ms ease-out'))
      ])
   ]
})
export class ShareListComponent implements OnInit, OnDestroy {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   @Input() selectedItems: any[];
   @Input() search = false;
   @Input() trash = false;
   @Input() role = 'Admin';
   @Input() tin;
   @Input() shared = false;
   @Input() sharelink = false;
   @Input() hideInfo = false;
   @Input() canDrag = true;
   @Input() isListDoc = true;
   @Input() isDownload = true;
   @Input() sharedbyme = false;
   @Output() clickitem = new EventEmitter<any>();
   @Output() loadmore = new EventEmitter<any>();
   @Output() showdocument = new EventEmitter<any>();
   @Output() searchpos = new EventEmitter<number>();
   @Output() uploadNewVersion = new EventEmitter<any>();
   @ViewChild('description') descElement: ElementRef;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   @ViewChild('form2', {read: ViewContainerRef}) form2: ViewContainerRef;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   private loading: boolean;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px
   private path: string;
   private dataFolder: any;
   public paths: any[] = [];
   types: any[];
   items: any[] = [];
   info: any;
   activeItem: any;
   selectedTab: number;
   saveText = 'Save';
   hasMore: boolean;
   form: any;
   previewLoaded = false;
   extention = '';
   isBusiness: boolean;
   item: any;
   object_file: any;
   selectFile: any;
   shiftPressed = false;
   action_status = true;
   collapseInfo: boolean;
   user: any;
   comment: any;
   crl: boolean;
   sourceItem: any;
   post = 'ส่ง';
   permMove = true;
   corporatePath: string;
   nativeElement: any;
   isCheck: any;
   isDrag = false;
   permissionLevel = 0;

   constructor(private router: Router, public service: IdexService,
               private resolver: ComponentFactoryResolver, public dialog: MatDialog,
               private translate: TranslateService, private toast: Toast, private sanitizer: DomSanitizer,
               private app: AppComponent, private elementRef: ElementRef) {
      this.nativeElement = this.elementRef.nativeElement;
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   ngOnInit(): void {
      this.items = undefined;

      this.service.role = this.role;
   }

   ngOnDestroy() {
      if (this.componentRef1) {
         this.componentRef1.destroy();
      }
      if (this.componentRef2) {
         this.componentRef2.destroy();
      }
   }

   @HostListener('window:resize')
   onResize() {
      this.collapseInfo = window.innerWidth < 900;
      const header = $('.doc-header');
      if (header.length === 0) {
         return;
      }
      header.css({width: $('.doclist').outerWidth(true)});
   }

   setItems(items: any[], hasMore: boolean, metaFolder?: any) {
      this.items = items;
      this.hasMore = hasMore;
      this.loading = false;
      this.activeItem = undefined;
      this.dataFolder = metaFolder;
      setTimeout(() => {
         this.onWindowScroll();
      }, 100);
   }

   addItems(items: any[], hasMore: boolean) {
      if (items && items.length > 0) {
         this.items.push.apply(this.items, items);
      }
      this.hasMore = hasMore;
      this.loading = false;
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item, this.trash);
   }

   hasThumbnail(item: any) {
      return Mimetype.hasThumbnail(item, this.trash);
   }

   hasPreview(): boolean {
      return !this.info.isFolder && Mimetype.hasPreview(this.info.mimeType);
   }

   openItem(event: Event, item: any) {
      event.stopPropagation();
      this.clickitem.emit(item);
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   onItemSelect(event: any, item: any) {
      event.preventDefault();
      this.isCheck = true;
      item.selected = !item.selected;
      const index = this.selectedItems.indexOf(item);
      if (item.selected) {
         if (index === -1) {
            this.selectedItems.push(item);
         }
      } else {
         if (index !== -1) {
            this.selectedItems.splice(index, 1);
         }
      }
   }

   onItemClickMenu(event: any, item: any) {
      event.preventDefault();
      this.isCheck = false;
      this.items.forEach(o => {
         o.selected = false;
         const indexDel = this.selectedItems.indexOf(o);
         if (indexDel !== -1) {
            this.selectedItems.splice(indexDel, 1);
         }
      });
      item.selected = true;
      if (this.selectedItems.indexOf(item) === -1) {
         this.selectedItems.push(item);
      }
   }

   onItemClick(event: any, item: any) {
      event.preventDefault();
      if (this.shared) {
         this.permissionLevel = item.permissionLevel;
      }
      if (event.ctrlKey || event.metaKey) {
         this.isCheck = false;
         item.selected = !item.selected;
         const index = this.selectedItems.indexOf(item);
         if (item.selected) {
            if (index === -1) {
               this.selectedItems.push(item);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }

         if (this.activeItem) {
            if (!this.activeItem.selected) {
               this.activeItem = this.info = undefined;
            }
            let active;
            for (const o of this.items) {
               if (o.selected) {
                  if (active) {
                     return;
                  }
                  active = o;
               }
            }
            if (active) {
               this.activeItem = active;
               this.loadInfo(active);
            }
            return;
         }
      } else if (event.shiftKey) {
         event.preventDefault();
         let from = this.activeItem ? this.items.indexOf(this.activeItem) : 0;
         let to = this.items.indexOf(item);
         if (to < from) {
            const x = from;
            from = to;
            to = x;
         }
         for (let i = 0; i < this.items.length; i++) {
            this.items[i].selected = i >= from && i <= to;
            if (this.items[i].selected) {
               if (this.selectedItems.indexOf(this.items[i]) === -1) {
                  this.selectedItems.push(this.items[i]);
               }
            }
         }
         this.isCheck = false;
         if (from !== to) {
            return;
         }
      } else if (this.activeItem === item) {
         if (!this.isCheck) {
            this.items.forEach(o => {
               if (o !== this.activeItem) {
                  o.selected = false;
                  const indexDel = this.selectedItems.indexOf(o);
                  if (indexDel !== -1) {
                     this.selectedItems.splice(indexDel, 1);
                  }
               }
            });
            item.selected = true;
            if (this.selectedItems.indexOf(item) === -1) {
               this.selectedItems.push(item);
            }
         }
         this.isCheck = false;
         return;
      } else {
         if (!this.isCheck) {
            this.items.forEach(o => {
               o.selected = false;
               const indexDel = this.selectedItems.indexOf(o);
               if (indexDel !== -1) {
                  this.selectedItems.splice(indexDel, 1);
               }
            });
            item.selected = true;
            if (this.selectedItems.indexOf(item) === -1) {
               this.selectedItems.push(item);
            }
         }
      }

      this.info = undefined;
      this.previewLoaded = false;
      if (this.selectedItems.length <= 1) {
         this.activeItem = item;
         this.loadInfo(item);
      }
      this.isCheck = false;
   }

   loadInfo(item: any) {
      if (item.info) {
         this.showInfo(item.info);
      } else {
         let getDocument;
         getDocument = this.service.getShareDocument(item.id, '');
         getDocument.subscribe(data => {
            if (this.activeItem.id !== data.id) {
               return;
            } // too late, just ignore it!
            if (this.trash) {
               data.description = data.description || '-';
            }
            this.showInfo(item.info = data);
            this.form = undefined; // clear form
         });
      }
   }

   download(item: any) {
      if (item.isFolder) {
         this.dialog.open(ShareDownloadFolderComponent, {
            disableClose: true,
            data: {
               id: item.id,
               name: item.name,
               service: this.service
            }
         });
      } else {
         location.href = this.service.url + '/share-public/download?id=' + item.id;
      }
   }

   getVersion(item: any): string {
      if (item.version.substring(item.version.length - 2) === '.0') {
         return 'v' + item.version.substring(0, item.version.length - 2);
      }
      return 'v' + item.version;
   }

   private showInfo(data: any) {
      this.comment = data.comments;
      this.info = data;
      const noMetadata = this.selectedTab === undefined || data.isFolder || (this.trash && !data.typeName);
      this.selectTab(noMetadata ? 0 : this.selectedTab);
      setTimeout(() => {
         if (!this.trash && data.properties) {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, data.properties);
         }
         this.updateContainerHeight();
      }, 200);
   }

   private updateContainerHeight() {
      setTimeout(() => {
         const height = $('.info-body:visible').outerHeight(true) + $('.info-title-share').outerHeight(true);
         this.adjustInfoPosition();
      }, 100);
   }

   selectTab(index: number) {
      this.selectedTab = index;
      setTimeout(() => {
         const e = $('.title-label:eq(' + index + ')');
         if (e.length > 0) {
            $('.indicator').css({left: e.position().left, width: e.outerWidth(true)});
         }
         if (this.descElement) {
            this.descElement.nativeElement.value = this.info.description || '';
         }
         this.adjustInfoPosition();
      }, 100);
   }

   @HostListener('window:scroll')
   onWindowScroll() {
      if (this.hasMore && !this.loading) {
         if (window.innerHeight + window.pageYOffset + 1 >= document.body.scrollHeight) {
            this.loading = true;
            this.loadmore.emit();
         }
      }

      this.adjustInfoPosition();
   }

   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) {
         return;
      }

      const title = $('.info-title-share');
      const infoTop = title.position().top + title.outerHeight(true);
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
         }
      }
   }

   loadForm(option: any) {
      this.form = undefined;
      this.service.getShareType(option.value).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         this.updateContainerHeight();
      });
   }

   private checkGrantedScope(auth2: any, next: any): void {
      const user = auth2.currentUser.get();
      if (user.hasGrantedScopes(this.SCOPE)) {
         next();
      } else {
         const options = new gapi.auth2.SigninOptionsBuilder({'scope': this.SCOPE});
         user.grant(options).then(next,
            (error) => {
               this.toast.error(error);
            });
      }
   }

   onSelectFiles(input: any, item: any) {
      this.uploadNewVersion.emit({file: input.files, item: item});
   }

   errorImgHandler(event) {
      event.target.src = this.getIcon(this.info);
   }
}
